import { useApiDeleteRequest } from '@/api/rest/hooks/useApiDeleteRequest';
import { useApiPatchRequest } from '@/api/rest/hooks/useApiPatchRequest';
import { useApiPostRequest } from '@/api/rest/hooks/useApiPostRequest';

import {
  DELETE_JOB_PRODUCT_PATH,
  DeleteJobProductErrorDto,
  DeleteJobProductRequestPathVariables,
  JobProduct,
  PATCH_JOB_PRODUCT_PATH,
  PatchJobProductErrorDto,
  PatchJobProductRequestBodyData,
  PatchJobProductRequestPathVariables,
  POST_JOB_PRODUCT_PATH,
  PostJobProductErrorDto,
  PostJobProductRequestBodyData,
} from './types/jobProducts';

export const usePostJobProduct = () => {
  return useApiPostRequest<undefined, undefined, PostJobProductRequestBodyData, JobProduct, PostJobProductErrorDto>(
    POST_JOB_PRODUCT_PATH,
  );
};

export const usePatchJobProduct = () => {
  return useApiPatchRequest<
    PatchJobProductRequestPathVariables,
    undefined,
    PatchJobProductRequestBodyData,
    JobProduct,
    PatchJobProductErrorDto
  >(PATCH_JOB_PRODUCT_PATH);
};

export const useDeleteJobProduct = () => {
  return useApiDeleteRequest<DeleteJobProductRequestPathVariables, undefined, void, DeleteJobProductErrorDto>(
    DELETE_JOB_PRODUCT_PATH,
  );
};
